import { apiService } from 'services/axiosHandler';

const path = 'agencies';

export const getAgencyRequest = async (params = undefined, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.get(`/${path}`, { 
        params,
        headers
    });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const addAgencyRequest = async (payload, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.post(`/${path}`, payload, { headers });

    if (req.status !== 201) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const updateAgencyRequest = async (id, payload, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.patch(`/${path}/${id}`, payload, { headers });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const deleteAgencyRequest = async (id, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.delete(`/${path}/${id}`, { headers });

    if (req.status !== 204) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};


/**
 * config
 */

export const getAgencyConfigRequest = async (agencyId, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.get(`/${path}/${agencyId}/config`, {
        headers
    });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const updateAgencyConfigRequest = async (agencyId, payload, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.patch(`/${path}/${agencyId}/config`, payload, { headers });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};
  
export const deleteAgencyConfigRequest = async (agencyId, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }

    const req = await apiService.delete(`/${path}/${agencyId}/config`, { headers });

    if (req.status !== 204) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};


/**
 * sync
 */

export const syncAgencyRequest = async (agencyId, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.post(`/${path}/${agencyId}/sync`, {}, { headers });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const syncAgenciesRequest = async (agencyId, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.post(`/${path}/${agencyId}/sync-agencies`, {}, { headers });

    if (req.status !== 200) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};

export const syncAgencyMembersRequest = async (agencyId, selfRole = undefined) => {
    let headers;
    if(selfRole){
        headers = {
            'x-sipekad-self-role': selfRole
        }
    }
    
    const req = await apiService.post(`/${path}/${agencyId}/sync-members`, {}, { headers });

    if (req.status !== 204) {
        throw req.data.message || req.statusText || req
    }

    return req.data;
};